import { updateMetricByKey } from '@client/core/atoms/metrics.js';
import { updatePlacementKeyValueById } from '@client/core/atoms/placements.js';
import {
  type PlacementId,
  PlacementStatus
} from '@schibsted-nmp/advertising-shared';

const afsRequest = (container: PlacementId) => {
  updatePlacementKeyValueById(container, 'status', 'requested');
  updatePlacementKeyValueById(container, 'creativeType', 'banner');
  updateMetricByKey(container, PlacementStatus.AdLoaded);
  updatePlacementKeyValueById(container, 'status', 'loaded');

  renderMartailerPlaceholder(container);
};

export function triggerAfsRequest(container: PlacementId) {
  afsRequest(container);
}

function renderMartailerPlaceholder(placementId: PlacementId) {
  setTimeout(() => {
    const slotElement = document.getElementById(placementId);
    if (!slotElement) return;

    const placeholder = document.createElement('div');

    Object.assign(placeholder.style, {
      backgroundColor: '#f0f0f0',
      border: '1px solid #ccc',
      borderRadius: '10px',
      width: '100%',
      height: '396px',
      lineHeight: '396px',
      textAlign: 'center',
      gridColumn: '1 / 1'
    } as CSSStyleDeclaration);

    placeholder.textContent = 'Sponsored Listing';
    slotElement.innerHTML = '';
    slotElement.style.gridColumn = '1 / 1';
    slotElement.appendChild(placeholder);
  }, 1);
}
